export default "__VITE_ASSET__95a31b7f__"